import { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { motion as Motion, AnimatePresence } from "framer-motion";

export default function Tooltip({ children, content, position = "top" }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const show = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setCoords({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height,
      });
    }
    setVisible(true);
  };

  const hide = () => setVisible(false);

  const tooltipPosition = {
    top: {
      top: coords.top - 8,
      left: coords.left + coords.width / 3,
      transform: "translate(-50%, -100%)",
    },
    bottom: {
      top: coords.top + coords.height + 8,
      left: coords.left + coords.width / -0.15,
      transform: "translate(-50%, 0)",
    },
    left: {
      top: coords.top + coords.height / 3,
      left: coords.left - 8,
      transform: "translate(-100%, -50%)",
    },
    right: {
      top: coords.top + coords.height / 3,
      left: coords.left + coords.width + 8,
      transform: "translate(0, -50%)",
    },
    center: {
      top: coords.top + coords.height + 5,
      left: coords.left + coords.width / -0.25,
      transform: "translate(-25%, 0)",
    },
    center_xs: {
      top: coords.top + coords.height / 2,
      left:   '20%',
      right: '20%',
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <>
      <span
        ref={triggerRef}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        aria-describedby="tooltip"
        className="inline-flex"
      >
        {children}
      </span>

      {createPortal(
        <AnimatePresence>
          {visible && (
            <Motion.div
              id="tooltip"
              role="tooltip"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.2 }}
              style={{
                position: "absolute",
                zIndex: 100,
                ...tooltipPosition[position],
              }}
              className="sm:w-1/3 px-2 py-1 text-xs text-aw-green bg-aw-bluegray border border-aw-bluedark-75 font-medium rounded-md shadow-lg"
            >
              {content}
            </Motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
}
